var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(!_vm.ended)?_c('div',{class:_vm.clsName,on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.textIntro)+" "),(!_vm.started)?_c('span',[_vm._v(_vm._s(_vm.time))]):_vm._e()]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }